export const BLANK_USERNAME = 'Please enter a username';
export const EMAIL_AS_USERNAME = 'It looks as though you may have entered an email address. Please enter your username';
export const BLANK_PASSWORD = 'Please enter a password';
